const Header = () => {
    return (
        <header className="header">
            <h1>
                Nasa Crisis Tracker (Powered by Nasa API)
            </h1>
        </header>
    )
}

export default Header
